import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { ApiResponse } from "@src/api.types";
import React from "react";

export type EditMemberHistoryFeedbackModalProps = {
  // The response from the API, which indicates the success or failure of the update.
  editHistoryResponse: ApiResponse<undefined> | null | undefined;
  // Only used to clear the response after the user exits the modal.
  setEditHistoryResponse: (response: ApiResponse<undefined> | null | undefined) => void;
};

/**
 * Show a modal indicating whether the SDOH record update was successful or not.
 */
export function EditMemberHistoryFeedbackModal({
  editHistoryResponse,
  setEditHistoryResponse,
}: EditMemberHistoryFeedbackModalProps): React.JSX.Element {
  const response = editHistoryResponse;

  if (response == null) return <></>;

  const title = response?.status === "success" ? "Success" : "Error";

  return (
    <ModalDialog
      header={title}
      isOpen={true}
      onClose={() => setEditHistoryResponse(undefined)}
    >
      <div>
        {response?.status === "success" ? (
          <p>Member history updated successfully.</p>
        ) : (
          <p>Could not perform the specified update. Please try again in a moment.</p>
        )}
      </div>
    </ModalDialog>
  );
};


